/**
 * This provider is intended to use in conjunction
 * with AppVariablesResolver defined on the same route
 */

import { InjectionToken, FactoryProvider } from '@angular/core';

import { AppVariables } from './app-variables.interfaces';
import { AppVariablesService } from './app-variables.service';

export const APP_VARIABLES_TOKEN = new InjectionToken<AppVariables>('App Variables');

export const appVariablesProvider: FactoryProvider = {
  provide: APP_VARIABLES_TOKEN,
  useFactory: (appVariablesService: AppVariablesService) => appVariablesService.get(),
  deps: [AppVariablesService],
};
